import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Message } from 'redux/slices/message'

export interface MessageResponse {
  conversationId: string
  intents: Intent[]
  output: string[]
  timestamp: number
}

interface Intent {
  confidence: number
  intent: string
}

interface GarrySupportTicketRequest {
  client_auth_hash: string
  time: string
  support_email: string
  support_name?: string
  support_message: string
  issue_metadata: IssueMetadata
  support_subject: string
  support_category: string
  session_auth_hash?: string
  conversation_id: string
}

interface IssueMetadata {
  confidence: number
  chatlog: Omit<Message, 'time'>[]
  garry_version: number
}

const wsApiUrl = process.env.REACT_APP_WS_API_URL

export const wsApi = createApi({
  reducerPath: 'wsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: wsApiUrl,
  }),
  endpoints: builder => ({
    sendSupportTicket: builder.mutation<undefined, GarrySupportTicketRequest>({
      query: body => ({
        url: '/SupportTicket',
        method: 'POST',
        body,
      }),
    }),
  }),
})
